import React, { PureComponent } from 'react';

import { View } from 'react-native';
import styles from './websso.styles';
import Button from '@dbk/ui-buttons';
import Spinner from '@dbk/ui-spinner';
import InfoMessage from './info-message';
import { createContainer } from '@dbk-legacy/muster/react';
const element = document.getElementById('loggedInUserEmail');
const webssoLoggedInEmail =
  element != null ? document.getElementById('loggedInUserEmail').value : null;

class WebSSOConnect extends PureComponent {
  constructor(props) {
    super(props);
    this.onLoginClick = this.onLoginClick.bind(this);
  }
  componentDidMount() {
    this.props.globalauth.authorizeWebSSOUser({ webssoLoggedInEmail });
  }
  onLoginClick() {
    window.location.reload();
  }
  render() {
    const {
      webssoauthentication: { errorMessage, isSynced, webssoEnabled },
      auth: { noEntitlement },
      i18n: { messages },
    } = this.props;
    let webssoErrorMessage = errorMessage;
    let webssoFlag = webssoEnabled;
    if (webssoEnabled && noEntitlement) {
      webssoErrorMessage = messages['app.auth.noEntitlement'];
      webssoFlag = false;
    }
    return (
      <div className="websso-scene">
        <div className="icon-header">
          <i className="i i-login-text" />
          <i className="i i-login-logo" />
        </div>
        <div className="login">
          <div className="row">
            {!webssoFlag &&
              isSynced && (
                <div className="column small-12 medium-push-2 medium-8 large-push-2 large-8">
                  {webssoErrorMessage != undefined && (
                    <InfoMessage
                      messages={messages}
                      error={webssoErrorMessage}
                    />
                  )}
                  <div className="row">
                    <div className="small-12 medium-push-2 medium-8 column center login-ch">
                      <Button onClick={this.onLoginClick}>
                        {
                          messages[
                            'app.auth.vasco.authentication.returnToLogin'
                          ]
                        }
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            {webssoFlag &&
              !isSynced && (
                <div className="column small-12 medium-push-2 medium-8 large-push-2 large-8">
                  <div className="row">
                    <div className="progress-bar">
                      <Spinner size="small" />
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
        <i className="i login-btm" />
      </div>
    );
  }
}

export default createContainer({
  $renderError: () => <Error />,
  $queries: {
    replacePage: { $call: 'ui.history.replace' },
    webssoauthentication: {
      errorMessage: true,
      isSynced: true,
      webssoEnabled: true,
    },
    globalauth: {
      authorizeWebSSOUser: { $call: 'authorizeWebSSOUser' },
    },
    auth: {
      noEntitlement: true,
    },
    i18n: {
      messages: true,
    },
  },
})(WebSSOConnect);
